import type {RegistrationCountry} from './types';

type CitizenshipListItem = {
	id?: number;
	/** Бэк: `name` — например «Российская Федерация». */
	name?: string;
	country_name?: string;
	countryName?: string;
	/** Бэк: `oksm_code` — например «643». Не паддим: `51` и `051` — разные записи. */
	oksm_code?: string | null;
	oksmCode?: string | null;
};

const getCitizenshipName = (item: CitizenshipListItem): string | undefined => {
	return item.name ?? item.country_name ?? item.countryName;
};

export const normalizeCitizenshipsResponse = (data: unknown): CitizenshipListItem[] => {
	if (Array.isArray(data)) {
		return data as CitizenshipListItem[];
	}

	if (data && typeof data === 'object') {
		const record = data as Record<string, unknown>;

		if (Array.isArray(record.citizenships)) {
			return record.citizenships as CitizenshipListItem[];
		}

		if (Array.isArray(record.data)) {
			return record.data as CitizenshipListItem[];
		}

		if (Array.isArray(record.countries)) {
			return record.countries as CitizenshipListItem[];
		}
	}

	return [];
};

export const mapCitizenshipsToRegistrationCountries = (items: CitizenshipListItem[]): RegistrationCountry[] => {
	return items
		.map((item): RegistrationCountry | null => {
			const oksmCode = item.oksm_code ?? item.oksmCode;

			const name = getCitizenshipName(item);

			if (!name || oksmCode == null || oksmCode === '') {
				return null;
			}

			return {
				oksmCode: String(oksmCode).trim(),
				name,
			};
		})
		.filter((country): country is RegistrationCountry => country !== null);
};
